import styled, { css } from "styled-components";

export const WrapperInput = styled.div`
  width: 100%;
`;

export const FieldWrapper = styled.div`
  position: relative;
`;

export const StyledInput = styled.input<{
  isError: boolean;
  isSearch?: boolean;
  icon?: string;
  isShadow?: boolean;
}>`
  width: 100%;
  padding: ${({ isSearch, icon, type }) =>
    isSearch
      ? "12px 100px 12px 60px"
      : icon
      ? "12px 11px 12px 75px"
      : "12px 16px"};
  font-family: var(--font-brand);
  background-color: var(--color-white);
  border: 2px solid
    ${({ isError }) =>
      isError ? "var(--color-red-200)" : "var(--color-gray-200)"};
  box-shadow: ${({ isShadow }) =>
    isShadow ? "0px 0px 40px rgba(0, 0, 0, 0.15);" : "none"};
  border-radius: 5px;
  transition: 0.4s;

  &:disabled {
    cursor: not-allowed;
  }

  ${({ isError, isShadow }) => css`
    &:hover:not(:disabled) {
      border-color: ${isError ? "var(--color-red-200)" : "rgba(0, 0, 0, 0.3)"};
    }

    &:focus:not(:disabled) {
      box-shadow: ${isShadow ? "0px 4px 30px 5px rgba(0, 0, 0, 0.2)" : "none"};
      border-color: var(--primary);
    }
  `}

  @media (min-width: 768px) {
    padding: ${({ isSearch, icon, type }) =>
      isSearch
        ? "12px 60px 12px 60px"
        : icon
        ? "12px 11px 12px 75px"
        : "12px 16px"};
  }

  @media (min-width: 1440px) {
    padding: ${({ isSearch, icon, type }) =>
      isSearch
        ? "12px 60px 12px 60px"
        : icon
        ? "12px 11px 12px 75px"
        : "12px 16px"};
  }
`;

export const StyledLabel = styled.span<{ isRequired?: boolean }>`
  display: inline-block;
  margin-bottom: 14px;
  font-size: 18px;
  line-height: 1.26;
  color: var(--color-gray-900);
  padding-left: 8px;

  ${({ isRequired }) =>
    isRequired
      ? css`
          &::after {
            content: "*";
            color: var(--color-red-200);
            margin-left: 3px;
          }
        `
      : css`
          &::after {
            content: "";
            display: none;
          }
        `};
`;

export const ErrorMessage = styled.span`
  display: block;
  position: absolute;
  padding-top: 6px;
  font-size: 12px;
  line-height: 1.26;
  color: var(--color-red-200);
`;

export const StyledIconWrapper = styled.div<{ isSearch?: boolean }>`
  position: absolute;
  left: ${({ isSearch }) => (isSearch ? "25px" : "24px")};
  top: 50%;
  transform: translateY(-50%);

  ${({ isSearch }) =>
    !isSearch
      ? css`
          &::after {
            content: "";
            display: block;
            position: absolute;
            top: -13px;
            left: 42px;
            height: 51px;
            width: 2px;
            background-color: var(--color-gray-200);
          }
        `
      : css`
          &::after {
            content: "";
            display: none;
          }
        `};
`;
